module.exports = __webpack_public_path__ + "static/media/chatie_logo.67c958d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chatie_logo.png
// module id = 234
// module chunks = 0